module.exports = __webpack_public_path__ + "static/media/Croagunk_gaussian2.539987ab.png";